const data = {
  "breadcrumbs": {
    "ariaLabel": "Broodkruimels"
  },
  "carousel": {
    "ariaLabelPrev": "Vorige",
    "ariaLabelNext": "Volgende"
  },
  "collapse": {
    "labelCollapsed": "Meer weergeven",
    "labelExpanded": "Minder weergeven"
  },
  "drawer": {
    "ariaLabelClose": "Sluiten"
  },
  "modal": {
    "ariaLabelClose": "Sluiten"
  },
  "pagination": {
    "ariaLabelPagination": "Paginering",
    "ariaLabelGoTo": "ga naar pagina {page}",
    "ariaLabelNext": "volgende pagina",
    "ariaLabelPrev": "vorige pagina",
    "labelNext": "Volgende",
    "labelPrev": "Vorige"
  },
  "passwordStrengthIndicator": {
    "labelStrengthIndicator": "Sterkte:",
    "description": "Tip: gebruik nummers, hoofdletters en woorden."
  },
  "popover": {
    "ariaLabelClose": "Sluiten"
  },
  "reviewRating": {
    "ariaLabelRating": "Beoordeling is {value} van de 10.",
    "ariaLabelReviewCountSingular": "Beoordeling is {value} van de 10, gebaseerd op {reviewCount} review.",
    "ariaLabelReviewCountPlural": "Beoordeling is {value} van de 10, gebaseerd op {reviewCount} reviews.",
    "labelFirstReview": "Schrijf de eerste review",
    "labelReviewSingular": "{value} review",
    "labelReviewPlural": "{value} reviews",
    "labelEmphasizedSingular": "Gebaseerd op {value} review",
    "labelEmphasizedPlural": "Gebaseerd op {value} reviews"
  },
  "tabs": {
    "ariaLabelPrev": "Vorige",
    "ariaLabelNext": "Volgende"
  },
  "map": {
    "ariaLabelZoomIn": "Inzoomen",
    "ariaLabelZoomOut": "Uitzoomen",
    "ariaLabelPanUp": "Kaart omhoog verplaatsen",
    "ariaLabelPanDown": "Kaart omlaag verplaatsen",
    "ariaLabelPanLeft": "Kaart naar links verplaatsen",
    "ariaLabelPanRight": "Kaart naar rechts verplaatsen",
    "ariaLabelShowPan": "Pijlbesturing tonen",
    "ariaLabelHidePan": "Pijlbesturing verbergen",
    "ariaLabelEnterFullscreen": "Volledig scherm openen",
    "ariaLabelExitFullscreen": "Volledig scherm afsluiten"
  }
};

export default data;